import { CustomerAutocompleteField } from '@forms/Fields/Customer';
import { ResearchFormFieldDefinition } from './types';
import { DriverAutocompleteField } from '@forms/Fields/Driver';
import { LocationAutocompleteField } from '@forms/Fields/Location';
import { ChassisField } from '@forms/Fields/Chassis';
import { UserField } from '@forms/Fields/User';
import { Field } from 'formik';
import { FormikAutocomplete } from '@forms/Components/AutocompleteInput';
import { FormikMultiSelectChip } from '@forms/Components/MultiSelectChipInput';
import { FormikDateRangePicker } from '@forms/Components/DateRangePicker';
import { FormikTextInput } from '@forms/Components/TextInput';

import styles from './ResearchGridToolbar.module.css';

/**
 * Renders the appropriate Formik input for a filter field's data type.
 */
export function renderFilterField(definition: ResearchFormFieldDefinition) {
  switch (definition.dataType) {
    case 'customer':
      return (
        <CustomerAutocompleteField
          fieldName={definition.fieldName}
          className={`${styles['form-field']} ${styles['text-field']}`}
        />
      );
    case 'driver':
      return (
        <DriverAutocompleteField
          fieldName={definition.fieldName}
          className={`${styles['form-field']} ${styles['text-field']}`}
        />
      );
    case 'chassis':
      return (
        <ChassisField
          fieldName={definition.fieldName}
          className={`${styles['form-field']} ${styles['text-field']}`}
        />
      );
    case 'user':
      return (
        <UserField
          fieldName={definition.fieldName}
          className={`${styles['form-field']} ${styles['text-field']}`}
        />
      );
    case 'location':
      return (
        <LocationAutocompleteField
          fieldName={definition.fieldName}
          label={definition.label}
          className={`${styles['form-field']} ${styles['location-field']}`}
        />
      );
    case 'container':
      return (
        <Field
          name={definition.fieldName}
          label={definition.label}
          placeholder={definition.placeholder}
          component={FormikMultiSelectChip}
          className={`${styles['form-field']} ${styles['text-field']}`}
        />
      );
    case 'dateRange':
      return (
        <Field
          name={definition.fieldName}
          component={FormikDateRangePicker}
          label={definition.label}
          className={styles['date-range-input']}
        />
      );
    case 'charges':
      return (
        <Field
          name={definition.fieldName}
          label={definition.label}
          placeholder='Select Charges'
          component={FormikAutocomplete}
          className={`${styles['form-field']} ${styles['text-field']}`}
          autoCompleteItems={['All', 'Only Unapproved', 'Only Approved']}
        />
      );
    case 'text':
    default:
      return (
        <Field
          name={definition.fieldName}
          label={definition.label}
          placeholder={definition.placeholder}
          component={FormikTextInput}
          className={`${styles['form-field']} ${styles['text-field']}`}
        />
      );
  }
}
